import { render, staticRenderFns } from "./TileProductGiveawayPercent.vue?vue&type=template&id=71bc41cc"
import script from "./TileProductGiveawayPercent.vue?vue&type=script&lang=js"
export * from "./TileProductGiveawayPercent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports